// src/utils/version-check.ts
export function initVersionCheck() {
  if (import.meta.env.VITE_APP_ENV === "dev" || import.meta.env.VITE_APP_ENV === "prod") {
    const currentVersion = document.querySelector("script[version]")?.getAttribute("version");

    setInterval(() => {
      fetch("/index.html", { cache: "no-store" })
        .then(response => response.text())
        .then(html => {
          const newVersion = html.match(/version="(\d+)"/)?.[1];
          if (newVersion && currentVersion && newVersion !== currentVersion) {
            // New version detected
            window.location.reload();
          }
        });
    }, 60000); // Check every minute
  }
}
